import { render, staticRenderFns } from "./InsurancePopup.vue?vue&type=template&id=541bf2a8&scoped=true&"
import script from "./InsurancePopup.vue?vue&type=script&lang=js&"
export * from "./InsurancePopup.vue?vue&type=script&lang=js&"
import style0 from "./InsurancePopup.vue?vue&type=style&index=0&id=541bf2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541bf2a8",
  null
  
)

export default component.exports